import React, {Component} from "react";
import './ProgressBar.css';

export default class ProgressBar extends Component {

    render() {
        const fillerStyles = {
            height: '100%',
            width: `${this.props.percentageProgress || 0}%`,
            backgroundColor: '#982b6b',
            borderRadius: '20px',
            textAlign: 'right',
        }

        const labelStyles = {
            padding: '5px',
            color: '#fff',
            fontWeight: 'bold'
        }
        return (
            <div className={"loading-bar"}>
                <div style={fillerStyles}>
                    <span style={labelStyles}>{this.props.percentageProgress || 0}%</span>
                </div>
            </div>
        );
    }
}